import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE);

export default selector;

export const dashboardResponseSelector = createSelector(
  selector,
  (store) => {
    let{ response } = store;
    if (!response) {
      return null;
    }

    // Need to add viewerSessionsTable for old saving data
    if (!response.config || !response.config.viewerSessionsTable) {
      response = {
        ...response,
        config: {
          ...response.config,
          viewerSessionsTable: {
            selectedMetrics: [],
          },
        },
      };
    }
    if (!response.config.base) {
      response.config.base = {};
    }
    return response;
  },
);

export const dashboardIsFetchingSelector = createSelector(
  selector,
  store => store.isFetching,
);
